
export const ADD_EVENTS = 'ADD_EVENTS';
export const EVENTS_LOADING = 'EVENTS_LOADING';
export const ADD_EVENT = 'ADD_EVENT';
export const DELETE_EVENT = 'DELETE_EVENT';
export const UPDATE_EVENT = 'UPDATE_EVENT';

export const ADD_ALL_CHANNELS = 'ADD_ALL_CHANNELS';
export const ADD_CHANNEL = 'ADD_CHANNEL';
export const DELETE_CHANNEL = 'DELETE_CHANNEL';

export const ADD_SUBSCRIPTIONS = 'ADD_SUBSCRIPTIONS';
export const SUBSCRIBE_CHANNEL_START = 'SUBSCRIBE_CHANNEL_START';
export const SUBSCRIBE_CHANNEL_SUCCESS= 'SUBSCRIBE_CHANNEL_SUCCESS';
export const SUBSCRIBE_CHANNEL_FAIL = 'SUBSCRIBE_CHANNEL_FAIL';

export const ADD_USER_DATA = 'ADD_USER_DATA';
export const ADD_USER_CLAIMS = 'ADD_USER_CLAIMS';
export const DELETE_USER = 'DELETE_USER';

export const MAKE_CHAT_FAVORITE_START = 'MAKE_CHAT_FAVORITE_START';
export const MAKE_CHAT_FAVORITE_SUCCESS = 'MAKE_CHAT_FAVORITE_SUCCESS';
export const MAKE_CHAT_FAVORITE_FAIL = 'MAKE_CHAT_FAVORITE_FAIL';

export const SAVE_EVENT_START = 'SAVE_EVENT_START';
export const SAVE_EVENT_SUCCESS = 'SAVE_EVENT_SUCCESS';
export const SAVE_EVENT_FAIL = 'SAVE_EVENT_FAIL';

export const POPUP_CONTRIBUTOR = 'POPUP_CONTRIBUTOR';
export const POPUP_PAYMENT = 'POPUP_PAYMENT';
export const SELECT_PAYMENT_EVENT = 'SELECT_PAYMENT_EVENT';
export const PREVIOUS_PATH = 'PREVIOUS_PATH';
export const ADD_CHAT_COMPANION = 'ADD_CHAT_COMPANION';
export const ADD_ALL_CHATS = 'ADD_ALL_CHATS';
export const DELETE_ALL_CHATS = 'DELETE_ALL_CHATS';
export const CONTROL_SIDEBAR = 'DELETE_ALL_CHATS';

export const UPDATE_MESSAGE_NOTIFICATION = 'UPDATE_MESSAGE_NOTIFICATION';

export const UPDATE_CHAT_STATUS = 'UPDATE_CHAT_STATUS';

export const DELETE_CONTRIBUTOR = 'DELETE_CONTRIBUTOR';



// WEBPACK FOOTER //
// ./src/constants/ActionTypes.js